module.exports = __webpack_public_path__ + "img/IconoFloorGraphic.a54dcee1.png";